/**
 * Labstep
 *
 * @module components/FilterPost/Report/Text/Form
 * @desc Filter Metadata form
 */

import {
  COMPARISON_OPTIONS,
  fieldComparison,
  fieldText,
} from 'labstep-web/components/FilterPost/NewIndex/Text/Form/fields';
import type { IFilterPostReportTextFormProps } from 'labstep-web/components/FilterPost/NewIndex/Text/Form/types';
import { FormReusableGroup } from 'labstep-web/core/Form/Reusable/Group';
import { PostFilter } from 'labstep-web/services/postFilter';
import type { PostFilterComparisonType } from 'labstep-web/services/postFilter/constants';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';
import type React from 'react';
import { useCallback, useState } from 'react';

export const getPostFilterText = (
  field: string,
  comparison: PostFilterComparisonType,
  path?: string,
) => {
  return new PostFilter([[field, comparison]], path);
};

export const FilterPostReportTextForm: React.FC<
  IFilterPostReportTextFormProps
> = ({
  addPostFilter,
  onDone,
  path,
  field,
  defaultValues,
  replace,
}) => {
  const [fields, setFields] = useState([fieldComparison]);

  const onSubmit = useCallback(
    (values): void => {
      const { comparison } = values;
      let { value } = values;
      if (comparison.value === PostFilterComparison.not_null) {
        value = undefined;
      }
      addPostFilter(
        getPostFilterText(field, comparison.value, path).getNode([
          value,
        ]),
        true,
      );
      onDone();
    },
    [path, addPostFilter],
  );

  return (
    <FormReusableGroup
      fields={fields}
      onSubmit={onSubmit}
      onDone={onDone}
      defaultValues={{
        comparison: COMPARISON_OPTIONS[1],
        ...defaultValues,
      }}
      onFormChange={({ comparison }): void => {
        if (!comparison) {
          return;
        }
        const newFields =
          comparison.value === PostFilterComparison.not_null
            ? [fieldComparison]
            : [fieldComparison, fieldText];
        if (fields.length !== newFields.length) {
          setFields(newFields);
        }
      }}
      addAnother={false}
    />
  );
};
